var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBreadcrumbIconTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79612 7.8227C4.64164 8.039 4.34224 8.06085 4.16112 7.86915L4.1236 7.82945C3.97774 7.67505 3.9587 7.43165 4.07861 7.25395L5.93365 4.98592L4.07864 2.74603C3.95874 2.56835 3.97777 2.32495 4.12364 2.17055L4.16115 2.13084C4.34227 1.93912 4.64167 1.96102 4.79615 2.17729L6.9146 4.71651C7.02845 4.8759 7.02845 5.09595 6.9146 5.2553L4.79612 7.8227Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBreadcrumbIconTablet);
export default __webpack_public_path__ + "static/media/chevron_breadcrumb_icon_tablet.c99b4c0cc96355b2e001ad0a3eb3029a.svg";
export { ForwardRef as ReactComponent };